import { Modal } from "antd";
import SizeBox from "@/components/SizeBox";
import { CommonPrimaryBtn } from "@/components/CommonBtn";
import host from "@/utils/host";
import AppCommonModal from "@/components/AppCommonModal";
import Image from "next/image";
import useLanguage from "@/hooks/useLanguage";

const AuthorizationModal = ({ show, onCancel }) => {
  const { t } = useLanguage();
  const a = 1;
  if ( a === 1 ) {
    return <AppCommonModal width={561}  show={show} onCancel={onCancel}>
      <div style={{ marginTop: "20px", lineHeight: "21px", color: "#222" }} className={"px-[24px] text-[14px]"}>
        <Image className={"mx-auto mb-[40px]"} width={194} height={158} src={"/images/auth/auth-icon.svg"} alt={""}></Image>
        <div className={"font-bold text-color5 leading-1.5 mb-4 text-[16px]"}>{t('auth.title')}</div>
        <div>
          <Image width={468} height={268} src={"/images/auth/auth-des-icon.svg"} alt={""}></Image>
        </div>
        <a href={`${host}/api/v2/tiktok/login`} target={"_blank"}>
          <CommonPrimaryBtn className={"rounded-[24px] mx-auto trans-all hover:!opacity-70 w-[349px] h-[44px] mt-[39px]"}>{t('auth.button')}</CommonPrimaryBtn>
        </a>
      </div>
    </AppCommonModal>;
  }

  return <Modal title={<div className={"text_222 font-bold text-[17px]"}>{t('auth.title')}</div>} centered footer={null} width={656} open={show} onCancel={(e) => {
    e.stopPropagation();
    onCancel();
  }}>
    <div style={{ marginTop: "50px", lineHeight: "21px", color: "#222" }} className={"px-[24px] text-[14px]"}>
      <ul style={{ listStyleType: "disc" }}>
        <li style={{ color: "#FF6A00", fontWeight: "bold" }}>
          {t('auth.attention')}
        </li>
        <li>
          {t('auth.after_auth')}
        </li>
        <ul style={{ marginLeft: "20px", listStyleType: "disc" }}>
          <li>
            {t('auth.view_marketplace')}
          </li>
          <li>
            {t('auth.view_showcase')}
          </li>
          <li>
            {t('auth.increase_commission')}
          </li>
          <li>
            {t('auth.check_sample')}
          </li>
        </ul>
        <li>
          {t('auth.select_all')}
        </li>
        <li>
          {t('auth.data_usage')}
        </li>
        <li>
          {t('auth.cancel_auth')}
        </li>
      </ul>

      <a href={`${host}/api/v2/tiktok/login`} target={"_blank"}>
        <CommonPrimaryBtn className={"rounded-[24px] h-[40px] mt-[39px]"}>{t('auth.button')}</CommonPrimaryBtn>
      </a>
    </div>
  </Modal>;
};

export default AuthorizationModal;
